'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ExpertAreaIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ExpertAreaIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Certified-Ribbon-2--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Certified Ribbon 2 Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M20.5 22.7c0 0.55 -0.378 0.755 -0.84 0.457L12 18.2l-7.66 4.96c-0.462 0.3 -0.84 0.093 -0.84 -0.457V1.7a1 1 0 0 1 1 -1h15a1 1 0 0 1 1 1Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m17.625 4.987 -6.032 8.2a0.793 0.793 0 0 1 -1.269 0.068L7 9.623"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

ExpertAreaIcon.propTypes = {
  sx: PropTypes.object
}
